//core
import React, {useRef} from "react";
import arePropsEqual from "react-fast-compare";
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { Box, Tooltip } from "@mui/material";

//hooks
import useDimensions from "../../../../../customHooks/useDimensions";

//selectors
import { selectWalletsData } from "../../../../../store/admin/agents/selectors";

import { selectWalletsData as selectAgentWalletsData } from "../../../../../store/agent/agents/selectors";
import { useUser } from "../../../../../store/common/user/useUser";

interface ITextProps {
  value: string;
  maxWidth?: number;
  width?: number;
}

const useStyles = makeStyles({
  text: {
    color: "inherit",
    width: "150px",
    display: "block",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
    //wordBreak: 'break-word'
  },
  block: {
    position: "relative",
    color: "inherit",
    display: "block",
    width: "100%",
    minWidth: "60px",
  },
  wrapper: {
    width: "max-content",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});


const BrandName = ({ value, maxWidth = 200, width = 150 }: ITextProps) => {
  const styles = useStyles();
  const wrapperRef: any = useRef(null);
  const size = useDimensions(wrapperRef);

  const { user } = useUser();

  const walletsData = useSelector(user.user.namespace === 'agent' ? selectAgentWalletsData : selectWalletsData);
  const displayValue = walletsData?.wallets?.find((w: any) => w.brand === value)?.brandName || value;

  return (
    <>
      <Box className={`${styles.block} tooltipText`} sx={{ maxWidth: `${maxWidth}px` }}>
        <Box ref={wrapperRef} className={styles.wrapper}
             sx={{ opacity: 0, visibility: "hidden", position: "absolute" }}
        >
          { displayValue }
        </Box>
        {
          (size.width === maxWidth) ? (
            <Tooltip title={displayValue}>
                  <span className={styles.text} style={{ width: `${width}px` }}>
                    { displayValue }
                  </span>
            </Tooltip>
          ) : (
            <Box className={styles.wrapper}>
                  <span className={styles.text} style={{ width: `${width}px` }}>
                    { displayValue ? displayValue : '—' }
                  </span>
            </Box>
          )
        }
      </Box>
    </>
  );
};

export default React.memo(BrandName, arePropsEqual);
